import { useLocation, useNavigate } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-brown-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-brown-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 rounded-full bg-gold-100 flex items-center justify-center mx-auto mb-4">
          <span className="w-8 h-8 flex items-center justify-center text-gold-600">
            <i className="ri-error-warning-line text-2xl"></i>
          </span>
        </div>
        <h1 className="text-xl md:text-2xl font-semibold text-brown-900 mt-6">页面未找到</h1>
        <p className="mt-2 text-base text-brown-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-brown-500">该页面不存在或正在开发中</p>
        <button
          onClick={() => navigate('/home')}
          className="mt-6 px-6 py-3 rounded-full bg-gold-500 text-brown-950 text-sm font-semibold cursor-pointer whitespace-nowrap"
        >
          返回首页
        </button>
      </div>
    </div>
  );
}